import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
    viewItinerary: {
        id: 'components.bookings.booking.viewItinerary',
        defaultMessage: 'View Itinerary'
    }
});

export function getTranslatedViewItineraryString(translator: (msg: FormattedMessage.MessageDescriptor, values?: any) => string): string {
    return translator(messages.viewItinerary);
}
